(() => {
  function createLocalDate(dateString) {
    if (!dateString) return null;

    const parts = dateString.split("-").map(Number);

    if (parts.length !== 3) return null;

    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function initialiseEventCalendar(root) {
    if (!root || root.dataset.jrCalendarInitialised === "true") {
      return;
    }

    const source = root.querySelector("[data-jr-event-source]");
    const upcomingGrid = root.querySelector(
      "[data-jr-upcoming-grid]"
    );
    const pastGrid = root.querySelector("[data-jr-past-grid]");

    if (!source || !upcomingGrid || !pastGrid) return;

    root.dataset.jrCalendarInitialised = "true";

    const cards = Array.from(
      source.querySelectorAll("[data-jr-event-card]")
    );

    const tabs = Array.from(
      root.querySelectorAll("[data-jr-calendar-tab]")
    );

    const panels = Array.from(
      root.querySelectorAll("[data-jr-calendar-panel]")
    );

    const monthFilter = root.querySelector(
      '[data-jr-event-filter="month"]'
    );

    const locationFilter = root.querySelector(
      '[data-jr-event-filter="location"]'
    );

    const brandFilter = root.querySelector(
      '[data-jr-event-filter="brand"]'
    );

    const clearButton = root.querySelector(
      "[data-jr-clear-filters]"
    );

    const upcomingCount = root.querySelector(
      "[data-jr-upcoming-count]"
    );

    const pastCount = root.querySelector(
      "[data-jr-past-count]"
    );

    let activeTab = "upcoming";

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    cards.forEach((card) => {
      const endDate = createLocalDate(card.dataset.endDate);
      const status =
        endDate && endDate < today ? "past" : "upcoming";

      card.dataset.status = status;

      if (status === "past") {
        pastGrid.appendChild(card);
      } else {
        upcomingGrid.appendChild(card);
      }
    });

    source.remove();

    function sortCards() {
      const upcomingCards = Array.from(
        upcomingGrid.querySelectorAll("[data-jr-event-card]")
      );

      const pastCards = Array.from(
        pastGrid.querySelectorAll("[data-jr-event-card]")
      );

      upcomingCards
        .sort((firstCard, secondCard) => {
          return (
            createLocalDate(firstCard.dataset.startDate) -
            createLocalDate(secondCard.dataset.startDate)
          );
        })
        .forEach((card) => upcomingGrid.appendChild(card));

      pastCards
        .sort((firstCard, secondCard) => {
          return (
            createLocalDate(secondCard.dataset.startDate) -
            createLocalDate(firstCard.dataset.startDate)
          );
        })
        .forEach((card) => pastGrid.appendChild(card));
    }

    function addOptions(select, values) {
      if (!select) return;

      values.forEach((item) => {
        const option = document.createElement("option");

        option.value = item.value;
        option.textContent = item.label;

        select.appendChild(option);
      });
    }

    function buildFilters() {
      const months = new Map();
      const locations = new Set();
      const brands = new Set();

      cards.forEach((card) => {
        const month = card.dataset.month;
        const monthLabel = card.dataset.monthLabel;
        const location = card.dataset.location.trim();
        const brand = card.dataset.brand.trim();

        if (month && monthLabel) {
          months.set(month, monthLabel);
        }

        if (location) locations.add(location);
        if (brand) brands.add(brand);
      });

      const monthOptions = Array.from(months.entries())
        .sort(([firstMonth], [secondMonth]) => {
          return firstMonth.localeCompare(secondMonth);
        })
        .map(([value, label]) => ({ value, label }));

      const locationOptions = Array.from(locations)
        .sort((firstLocation, secondLocation) => {
          return firstLocation.localeCompare(secondLocation);
        })
        .map((value) => ({
          value,
          label: value
        }));

      const brandOptions = Array.from(brands)
        .sort((firstBrand, secondBrand) => {
          return firstBrand.localeCompare(secondBrand);
        })
        .map((value) => ({
          value,
          label: value
        }));

      addOptions(monthFilter, monthOptions);
      addOptions(locationFilter, locationOptions);
      addOptions(brandFilter, brandOptions);
    }

    function cardMatchesFilters(card) {
      const selectedMonth = monthFilter
        ? monthFilter.value
        : "";

      const selectedLocation = locationFilter
        ? locationFilter.value
        : "";

      const selectedBrand = brandFilter
        ? brandFilter.value
        : "";

      const matchesMonth =
        !selectedMonth ||
        card.dataset.month === selectedMonth;

      const matchesLocation =
        !selectedLocation ||
        card.dataset.location === selectedLocation;

      const matchesBrand =
        !selectedBrand ||
        card.dataset.brand === selectedBrand;

      return (
        matchesMonth &&
        matchesLocation &&
        matchesBrand
      );
    }

    function updateCalendar() {
      let visibleUpcoming = 0;
      let visiblePast = 0;

      cards.forEach((card) => {
        const matches = cardMatchesFilters(card);

        card.hidden = !matches;

        if (
          matches &&
          card.dataset.status === "upcoming"
        ) {
          visibleUpcoming += 1;
        }

        if (
          matches &&
          card.dataset.status === "past"
        ) {
          visiblePast += 1;
        }
      });

      if (upcomingCount) {
        upcomingCount.textContent = `(${visibleUpcoming})`;
      }

      if (pastCount) {
        pastCount.textContent = `(${visiblePast})`;
      }

      const upcomingEmpty = root.querySelector(
        '[data-jr-empty-state="upcoming"]'
      );

      const pastEmpty = root.querySelector(
        '[data-jr-empty-state="past"]'
      );

      if (upcomingEmpty) {
        upcomingEmpty.hidden = visibleUpcoming !== 0;
      }

      if (pastEmpty) {
        pastEmpty.hidden = visiblePast !== 0;
      }
    }

    function changeTab(tabName) {
      activeTab = tabName;

      tabs.forEach((tab) => {
        const isActive =
          tab.dataset.jrCalendarTab === activeTab;

        tab.classList.toggle("is-active", isActive);

        tab.setAttribute(
          "aria-selected",
          isActive ? "true" : "false"
        );
      });

      panels.forEach((panel) => {
        panel.hidden =
          panel.dataset.jrCalendarPanel !== activeTab;
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        changeTab(tab.dataset.jrCalendarTab);
      });
    });

    [monthFilter, locationFilter, brandFilter].forEach(
      (filter) => {
        if (filter) {
          filter.addEventListener(
            "change",
            updateCalendar
          );
        }
      }
    );

    if (clearButton) {
      clearButton.addEventListener("click", () => {
        if (monthFilter) monthFilter.value = "";
        if (locationFilter) locationFilter.value = "";
        if (brandFilter) brandFilter.value = "";

        updateCalendar();
      });
    }

    sortCards();
    buildFilters();
    changeTab(activeTab);
    updateCalendar();
  }

  function initialiseAllEventCalendars(container = document) {
    const calendars = container.querySelectorAll(
      "[data-jr-event-calendar]"
    );

    calendars.forEach((calendar) => {
      initialiseEventCalendar(calendar);
    });
  }

  function startCalendars() {
    initialiseAllEventCalendars();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startCalendars
    );
  } else {
    startCalendars();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initialiseAllEventCalendars(event.target);
    }
  );
})();